import { render, staticRenderFns } from "./cms-block-builder.vue?vue&type=template&id=08acc3d9&scoped=true"
import script from "./cms-block-builder.vue?vue&type=script&lang=js"
export * from "./cms-block-builder.vue?vue&type=script&lang=js"
import style0 from "./cms-block-builder.vue?vue&type=style&index=0&id=08acc3d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08acc3d9",
  null
  
)

export default component.exports